import { CustomContent } from '@models';
import { BaseContentComponent } from '../base-content.component';
import defaultHtml from './custom-content.component.hbs';

export class CustomContentComponent extends BaseContentComponent<CustomContent> {
    protected override bindEvent = undefined;
    protected override customTemplatePropertyName = 'customContent';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data) {
            return '';
        }

        const html = template(this.data);

        return html;
    }
}
